import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AmplifyError } from '../services/auth.types';

export const ChangeEmailActions = createActionGroup({
  source: 'User Account Change Email',
  events: {
    'Open Verify Password Dialog': props<{ invalidPassword: boolean }>(),
    'Submit Verify Password': props<{ password: string }>(),
    'Cancel Verify Password': emptyProps(),
    'Password Verified': emptyProps(),
    'Password Rejected': props<{ error: unknown }>(),
    'Open Change Email Dialog': props<{ currentEmail: string }>(),
    'Update Cognito': props<{ newEmail: string }>(),
    'Update Cognito Success': props<{ newEmail: string }>(),
    'Update Cognito Failure': props<{ error: AmplifyError }>(),
    'Confirmation Code Sent': props<{ newEmail: string }>(),
    'Submit Confirmation Code': props<{ newEmail: string; code: string }>(),
    'Resend Confirmation Code': props<{ newEmail: string }>(),
    'Confirmation Code Verified': props<{ newEmail: string }>(),
    'Confirmation Code Failed': props<{ error: unknown; newEmail: string }>(),
    'Reopen Confirmation Code With Error': props<{ message: string; newEmail: string }>(),
    'Update Email Cancelled': emptyProps(),
    'Update Person Email': props<{ newEmail: string }>(),
    'Update Person Email Success': emptyProps(),
    'Update Person Email Failed': props<{ newEmail: string; error: unknown }>(),
  },
});
